/* eslint-disable no-undef */
export default () => new Promise((resolve) => grecaptcha.ready(() => {
  grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_CLIENT, { action: 'submit' }).then((token) => {
    resolve(token)
  })
})
)
